import React, { useRef, useEffect } from "react";
import { RiPlayMiniFill, RiPauseMiniLine } from "react-icons/ri";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import {
  changePlayPausePlayList,
  changeTrack,
  changePlayPause,
} from "../../../../actions";

function Playlist_Card({
  data,
  isPlayListPlaying,
  playListId,
  changePlayPausePlayList,
  changeTrack,
  changePlayPause,
  isPlaying,
}) {
  const playPause = useRef();
  const mainCard = useRef();

  const { playListThumbnail, _id, playListTitle } = data;

  const showPlayPause = () => {
    playPause.current.style.opacity = 1;
    playPause.current.style.transform = "translateY(-16px)";
    mainCard.current.style.backgroundColor = "#2f2f2f";
  };
  const unShowPlayPause = () => {
    playPause.current.style.opacity = 0;
    playPause.current.style.transform = "translateY(0px)";
    mainCard.current.style.backgroundColor = "#1f1f1f";
  };

  const handleOnClickPlayPause = () => {
    changeTrack(data.playListSongs[0]._id);
    changePlayPause(!isPlaying);
    changePlayPausePlayList(!isPlayListPlaying, data._id);
  };
  return (
    <div className="relative">
      <Link to={`/playlist/${_id}`}>
        <div
          ref={mainCard}
          onMouseOver={showPlayPause}
          onMouseOut={
            !isPlayListPlaying && !isPlaying && playListId == data._id
              ? showPlayPause
              : unShowPlayPause
          }
          className="ml-5 mr-5 mt-10 bg-[#1f1f1f] p-4 pb-6 rounded-lg cursor-pointer  transition-all ease-in-out relative"
        >
          <div
            style={{
              backgroundImage: `url(${playListThumbnail})`,
              backgroundPosition: "center",
              backgroundRepeat: "no-repeat",
              backgroundSize: "cover",
              borderRadius: "50%",
              width: 180,
              height: 180,
              marginBottom: 20,
            }}
          ></div>
          <div className="">
            <h2
              style={{
                fontSize: 18,
                color: "white",
                marginBottom: 4,
                opacity: 0.8,
              }}
            >
              {playListTitle && playListTitle.substring(0, 20)}
            </h2>
            <p
              style={{
                fontSize: 12,
                opacity: 0.6,
                color: "white",
              }}
            >
              {/* {movie ? movie.substring(0, 30) : type} */}
            </p>
          </div>
        </div>
      </Link>
      <div
        onMouseOver={showPlayPause}
        ref={playPause}
        style={{ boxSizing: "border-box", padding: 8 }}
        className={`rounded-full  bg-[#1fdf64] ${
          !isPlayListPlaying &&
          !isPlaying &&
          playListId == data._id &&
          "opacity-100" &&
          "translate-y-[-36px]"
        } opacity-0 absolute right-10 bottom-20  transition-all ease-in-out flex items-center justify-center duration-300"`}
      >
        {!isPlayListPlaying && !isPlaying && playListId == data._id ? (
          <RiPauseMiniLine
            onClick={handleOnClickPlayPause}
            style={{
              fontSize: 30,
            }}
            className="text-black rounded-full cursor-pointer"
          />
        ) : (
          <RiPlayMiniFill
            onClick={handleOnClickPlayPause}
            style={{
              fontSize: 30,
            }}
            className="text-black rounded-full cursor-pointer"
          />
        )}
      </div>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    isPlayListPlaying: state.isPlayListPlaying,
    playListId: state.playListId,
    isPlaying: state.isPlaying,
  };
};

export default connect(mapStateToProps, {
  changePlayPausePlayList,
  changeTrack,
  changePlayPause,
})(Playlist_Card);
